import Vue from 'vue'
import {api} from "../resources"

export default {
    namespaced: true,
    state: {
        filters: {
            date_range: {
                start: null,
                end: null,
            },
            types: {
                transfer: true,
                expense: true,
                income: true,
            },
            account: null,
            expense_category: null,
            income_source: null,
            sort_type: '-',
            sort_by: 'date',
            keyword: null,
            showSearch: false
        },
        transactions: {
            data: [],
            dirty: false,
            data_length: 20,
            total_data: null
        },
        pagination: {
            current_page: 1,
            pages: null,
            'per-page': 20
        }
    },
    getters: {
        transactionsByDate: state => {
            const transactionsByDate = {}
            state.transactions.data.forEach((item) => {
                const date = Vue.prototype.$moment.unix(item[state.filters.sort_by]).startOf('day').format('DD-MM-YYYY');
                if (!transactionsByDate[date]) {
                    transactionsByDate[date] = []
                }
                transactionsByDate[date].push(item);
            })
            return transactionsByDate;
        },
        transactionFilters: (state, getters, rootState) => {
            return {
                space_id: rootState.space.current_space.data.id,
                date_start: Vue.prototype.$moment(state.filters.date_range.start, 'YYYY-MM-DD').unix(),
                date_end: Vue.prototype.$moment(state.filters.date_range.end, 'YYYY-MM-DD').endOf('day').unix(),
                is_income: state.filters.types.income ? 1 : 0,
                is_expense: state.filters.types.expense ? 1 : 0,
                is_transfer: state.filters.types.transfer ? 1 : 0,
                account_id: !!state.filters.account ? state.filters.account.id : '',
                expense_category_id: (!!state.filters.expense_category.id && (state.filters.types.expense || state.filters.types.transfer))
                    ? state.filters.expense_category.id
                    : '',
                income_source_id: (!!state.filters.income_source.id && state.filters.types.income)
                    ? state.filters.income_source.id
                    : '',
                keyword: state.filters.showSearch ? state.filters.keyword : '',
                sort: state.filters.sort_type + state.filters.sort_by,
                page: state.pagination.current_page,
                'per-page': state.pagination['per-page'],
            }
        }
    },
    actions: {
        getTransactions({rootState}, query) {
            const space_id = rootState.space.current_space.data.id;
            return api.transactions.get({space_id, ...query});
        },
        getFilteredTransactions({commit, rootState, state, getters}, showMore) {
            if (!state.transactions.data.length) commit('setFilteredTransactionsDirty');
            api.transactions.get({...getters['transactionFilters']})
                .then(res => {
                    if (res.body.success) {
                        if (showMore) {
                            commit('pushFilteredTransactions', res.body);
                        } else {
                            commit('setFilteredTransactions', res.body);
                        }
                    }
                })
        },
        getAllFilteredTransactions({commit, state, dispatch}) {
            commit('setPerPage', state.transactions.data_length);
            dispatch('getFilteredTransactions', false)
        },
        addTransaction: ({}, data) => api.transactions.save(data),
        updateTransaction: ({}, data) => api.transactions_id.update({id: data.id}, {...data}),
        transformTransaction({}, data) {
            return api.transaction_to_transfer.save({id: data.id}, {...data});
        },
        applyDateRange({commit, rootState}, date) {
            commit('setFilterByName', {
                name: 'date_range',
                value: {start: date.start, end: date.end}
            })
        },
        removeTransaction: ({}, id) => api.transactions_id.delete({id})
    },
    mutations: {
        setFilteredTransactionsDirty(state) {
            state.transactions.dirty = true;
        },
        setFilteredTransactions(state, body) {
            state.transactions.data = body.data.rows;
            state.transactions.data_length = body.data.length;

            state.transactions.total_data = {
                total: body.data.total,
                totalExpense: body.data.totalExpense,
                totalIncome: body.data.totalIncome,
                totalTransfers: body.data.totalTransfers
            };
            state.pagination.pages = Math.ceil(state.transactions.data_length / state.pagination['per-page']);
            state.transactions.dirty = false;
        },
        pushFilteredTransactions(state, body) {
            state.transactions.data = state.transactions.data.concat(body.data.rows)
        },
        setType(state, data) {
            state.filters.types[data.name] = data.val;
        },
        setFilterByName(state, payload) {
            state.filters[payload.name] = payload.value;
        },
        toggleSearch(state) {
            state.filters.showSearch = !state.filters.showSearch;
        },
        setPage(state, num) {
            state.pagination.current_page = num;
        },
        setPerPage(state, num) {
            state.pagination['per-page'] = num;
        },
        clearFilters(state) {
            state.filters.types = {
                transfer: true,
                expense: true,
                income: true,
            };
            state.filters.date_range = {start: null, end: null};
            state.filters.account = null;
            state.filters.expense_category = null;
            state.filters.income_source = null;
            state.filters.keyword = null;
            state.filters.showSearch = false;
        },
        resetPagination(state) {
            state.pagination = {current_page: 1, pages: null, 'per-page': 20}
        },
        clearTransactions(state) {
            state.transactions.data = [];
            state.transactions.total_data = {};
            state.pagination.current_page = 1;
            state.pagination.pages = null;
        }
    }
}